/* NORDE - colour swatch to gallery image (fallback layer).

   theme.js moves the gallery when the chosen swatch carries a data-media-id,
   which only happens once a photo has been attached to a variant in the
   admin. Products loaded without that step did nothing at all when a colour
   was picked. This file covers that case: it looks for a catalogue photo
   whose alt text names the colour and jumps to that instead. It drives the
   gallery through the goToMediaId hook theme.js exposes rather than scrolling
   the viewport itself, so the slide counter and arrows stay in step.

   Loaded after theme.js, so the hook exists by the time this runs. */
(function () {
  'use strict';

  function slideForColour(gallery, colour) {
    var needle = String(colour || '').trim().toLowerCase();
    if (!needle) return null;
    var slides = gallery.querySelectorAll('.gallery__slide[data-media-alt]');
    for (var i = 0; i < slides.length; i++) {
      var alt = slides[i].getAttribute('data-media-alt') || '';
      if (alt.indexOf(needle) > -1) return slides[i];
    }
    return null;
  }

  function jump(colour) {
    Array.prototype.slice.call(document.querySelectorAll('[data-gallery]')).forEach(function (g) {
      if (typeof g.goToMediaId !== 'function') return;
      var slide = slideForColour(g, colour);
      if (slide) g.goToMediaId(slide.getAttribute('data-media-id'));
    });
  }

  function init() {
    var inputs = document.querySelectorAll('[data-product-form] input[data-color-value]');
    Array.prototype.slice.call(inputs).forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        /* The swatch has its own photo: theme.js has already moved. */
        if (input.getAttribute('data-media-id')) return;
        jump(input.getAttribute('data-color-value'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
